'use strict'

import EventList from '@/pages/Event/EventList.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/events',
    name: 'Events',
    component: EventList,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/event.js